import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Typography, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import AppBackground from "../components/layout/AppBackground";

const CheckoutResult = () => {
  const { t } = useTranslation("checkout");
  const navigate = useNavigate();
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const success = query.get("success") === "true";
  const type = query.get("type"); // 'plan' o 'pack'
  const isFree = query.get("free") === "true";

  return (
    <AppBackground
    sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }}
    >
    <Container
        maxWidth="sm"
        sx={{
        textAlign: "center",
        p: 4,
        bgcolor: "rgba(0,0,0,0.75)",
        borderRadius: 4,
        boxShadow: 4,
        }}
    >
        {success ? (
            <CheckCircleOutlineIcon sx={{ fontSize: 56, color: "lightgreen", mb: 2 }} />
        ) : (
            <ErrorOutlineIcon sx={{ fontSize: 56, color: "tomato", mb: 2 }} />
        )}

        <Typography variant="h4" sx={{ color: "white", fontWeight: "bold", mb: 2 }}>
            {success
                ? isFree
                ? t("free_success_title")   // 🎉 Ej: "Compra gratuita completada"
                : t("payment_success_title")
                : isFree
                ? t("free_failed_title")    // ⚠️ Ej: "No se pudo completar la compra gratuita"
                : t("payment_failed_title")}
        </Typography>

        {success ? (
        <>
            <Typography variant="body1" sx={{ color: "white", mb: 3 }}>
            {isFree
                ? t("free_success_message")
                : type === "plan"
                ? t("payment_success_message_plan")
                : t("payment_success_message_pack")}
            </Typography>
            {!isFree && (
            <Typography variant="body1" sx={{ color: "white", mb: 3 }}>
                {t("payment_success_message_detailed")}
            </Typography>
            )}
        </>
        ) : (
        <Typography variant="body1" sx={{ color: "white", mb: 3 }}>
            {isFree ? t("free_failed_message") : t("payment_failed_message")}
        </Typography>
        )}

        <Box
        sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mt: 8,
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
        }}
        >

        {success && (
        <>
            <Button
                variant="contained"
                color="primary"
                sx={{ borderRadius: 999, minWidth: 180 }}
                onClick={() => navigate("/dashboard")}
            >
                {t("go_to_dashboard")}
            </Button>

            <Button
            variant="outlined"
            color="primary"
            sx={{ borderRadius: 999, minWidth: 180 }}
            onClick={() => navigate("/pitch")}
            >
            {t("start_practice")}
            </Button>
        </>
        )}

        {!success && (
            <>
                <Button
                variant="contained"
                color="primary"
                sx={{ borderRadius: 999, minWidth: 180 }}
                onClick={() => {
                    const params = location.state?.lastParams;
                    if (params) {
                    navigate(`/checkout${params}`);
                    } else {
                    navigate("/pricing");
                    }
                }}
                >
                    {t("try_again")}
                </Button>

                <Button
                variant="outlined"
                color="primary"
                sx={{ borderRadius: 999, minWidth: 180 }}
                onClick={() => {
                    navigate(`/contact`);
                }}
                >
                    {t("contact_support")}
                </Button>
            </>
        )}
        </Box>


  </Container>
    </AppBackground>
  );
};

export default CheckoutResult;
